import React, { FormEvent, useState } from 'react';
import Footer from '../../components/Footer';
import GitHubIcon from '@material-ui/icons/GitHub';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import Input from '../../components/Input';
import Textarea from '../../components/TextArea';
import './styles.css';
const Fade = require('react-reveal/Fade');

export default function ContactMe() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [telephone, setTelephone] = useState('');
    const [details, setDetails] = useState('');

    function handleOnSubmit(e: FormEvent){
        e.preventDefault();

        console.log(name, email, details)
        setName('');
        setEmail('');
        setDetails('');
    }

    return(
        <div id="contact-me" className="container">
            <legend>Contact</legend>
                <Fade bottom>
                    <div className="contact-form">
                        <form onSubmit={handleOnSubmit}>
                            <Input 
                                name="name" 
                                label="Name" 
                                type="text"
                                placeholder="Brian, James..."
                                value={name} 
                                onChange={(e) => {setName(e.target.value)}}
                                required={true}
                            />
                            <Input 
                                name="email" 
                                label="Email" 
                                type="email"
                                placeholder="undefined@undefined.com"
                                pattern="[A-Za-^([a-zA-Z0-9_-.]+)@([a-zA-Z0-9_-.]+).([a-zA-Z]{2,5})$]{3,}"
                                value={email} 
                                onChange={(e) => {setEmail(e.target.value)}}
                                required={true} 
                            />

                            <Input 
                                name="telephone" 
                                label="telephone" 
                                type="string"
                                placeholder="(xx)xxxxx-xxxx"
                                pattern="^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$"
                                value={telephone} 
                                onChange={(e) => {setTelephone(e.target.value)}}
                                required={true} 
                            />

                            <Textarea 
                                name="details" 
                                label="Details" 
                                placeholder="I need a web site..."
                                value={details} 
                                onChange={(e) => {setDetails(e.target.value)}}
                                required={true}
                            />
                            <button type="submit"> Send </button>
                        </form>
                        <div className="social-medias-container">   
                            <legend>Other contacts</legend>
                            <Fade left>
                                <a href="https://github.com/Brian-Mello" target="blank"><GitHubIcon className="github-icon"/></a>
                                <a href="https://twitter.com/Mello_Brian" target="blank"><TwitterIcon className="twitter-icon"/></a>
                            </Fade>
                            <Fade bottom>
                                <a href="https://www.instagram.com/brian_mello_" target="blank"><InstagramIcon className="instagram-icon"/></a>
                            </Fade>
                            <Fade right>
                                <a href="https://www.linkedin.com/in/brian-de-paula-mello-6b8577161/" target="blank"><LinkedInIcon className="linkedin-icon"/></a>
                                <a href="https://wa.me/5521982681935" target="blank"><WhatsAppIcon className="whatsapp-icon"/></a>
                            </Fade>
                        </div>
                    </div>
                </Fade>
            <Footer/>
        </div>
    )
};